// ABOUTME: The deck scene's build-in when 2A arrives from Ready for compass: the deck and sea rise into place while the scene fades in.
// ABOUTME: Shared by the deck sprite and the ocean scene so both play the same two animations on the same clock.
import { keyframes } from '@emotion/react';

const pvBIn = keyframes`
  from { transform: scale(0.9) translateY(24px); }
  to { transform: none; }
`;
const pvBFade = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

// The rise takes 1.5 s and the fade 1 s; both hold their first frame until they start.
export const buildInRise = {
  animationName: `${pvBIn}, ${pvBFade}`,
  animationDuration: '1.5s, 1s',
  animationTimingFunction: 'cubic-bezier(.2,.7,.2,1), ease',
  animationFillMode: 'both, both',
};

// The sky only fades; it does not rise.
export const buildInFade = {
  animationName: `${pvBFade}`,
  animationDuration: '1s',
  animationTimingFunction: 'ease',
  animationFillMode: 'both',
};
